import styles from "./CommonLoader.module.scss";

const CommonLoader = ({ size = 40, color = "#1648c6", overLayColor = "" }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    borderColor: `${color} transparent ${color} transparent`,
  };

  return (
    <div
      className={styles["loader-overlay"]}
      style={{ backgroundColor: overLayColor ?? "" }}
    >
      <div className={styles["loader"]} style={style}></div>
    </div>
  );
};

export default CommonLoader;
